import { Activite } from "../../../models/Activite";
import { Banniere } from "../../../models/Banniere";
import { Division } from "../../../models/Division";
import { Fournisseur } from "../../../models/Fournisseur";
import { Magasin } from "../../../models/Magasin";
import { Section } from "../../../models/Section";
import { Statut } from "../../../models/Statut";
import { ChipList, Chip, ChipProps } from "@progress/kendo-react-buttons";
import { User } from "../../../models/User";
import "./filterslist.css";
import { Keys } from "../../../constante/keys";
import { UrlParams } from "../../../constante/UrlParams";
import { Collection } from "../../../models/Collection";
import { useCallback } from "react";

interface FiltersListProps {
    sections: Section[];
    divisions: Division[];
    bannieres: Banniere[];
    magasins: Magasin[];
    fournisseurs: Fournisseur[];
    statuts: Statut[];
    activites: Activite[];
    acheteurs: User[];
    collections: Collection[];
    setCollection: React.Dispatch<React.SetStateAction<string>>;
    setSection: React.Dispatch<React.SetStateAction<string>>;
    setDivision: React.Dispatch<React.SetStateAction<string>>;
    setBanniere: React.Dispatch<React.SetStateAction<string>>;
    setMagasin: React.Dispatch<React.SetStateAction<string>>;
    setFournisseur: React.Dispatch<React.SetStateAction<string>>;
    setStatut: React.Dispatch<React.SetStateAction<string>>;
    setActivite: React.Dispatch<React.SetStateAction<string>>;
    setAcheteur: React.Dispatch<React.SetStateAction<string>>;
    updateObject: any;

    showUCCOnly: boolean;
    setShowUCCOnly: (value: boolean) => void;
}

export default function FiltersList(props: FiltersListProps) {
    const data = [
        { name: "Section", items: props.sections, key: Keys.Section, update: props.setSection, urlParam: UrlParams.Section },
        { name: "Division", items: props.divisions, key: Keys.Division, update: props.setDivision, urlParam: UrlParams.Division },
        { name: "Bannière", items: props.bannieres, key: Keys.Banniere, update: props.setBanniere, urlParam: UrlParams.Banniere },
        { name: "Magasin", items: props.magasins, key: Keys.Magasin, update: props.setMagasin, urlParam: UrlParams.Magasin },
        { name: "Fournisseur", items: props.fournisseurs, key: Keys.Fournisseur, update: props.setFournisseur, urlParam: UrlParams.Fournisseur },
        { name: "Statut", items: props.statuts, key: Keys.Statut, update: props.setStatut, urlParam: UrlParams.Statut },
        { name: "Activité", items: props.activites, key: Keys.Activite, update: props.setActivite, urlParam: UrlParams.Activite },
        { name: "Acheteur", items: props.acheteurs, key: Keys.Acheteur, update: props.setAcheteur, urlParam: UrlParams.Acheteur },
        { name: "Collection", items: props.collections, key: Keys.Collection, update: props.setCollection, urlParam: UrlParams.Collection },
        { name: "UCC", items: props.showUCCOnly, key: "UCC", update: props.setShowUCCOnly, urlParam: "ucc" },
    ]

    const getChipList = useCallback((chipProps: ChipProps) => {
        if (chipProps.dataItem.items.length === 0)
            return null;

        const name = chipProps.dataItem.name;
        
        if (Array.isArray(chipProps.dataItem.items)) {
            return chipProps.dataItem.items.map((d: any, i: number) => {
                return <Chip key={i} removable={true} rounded="large" size="small" className="status-chip"
                    onClick={() => props.updateObject(d, chipProps.dataItem.items, chipProps.dataItem.key, chipProps.dataItem.update, chipProps.dataItem.urlParam)}><b>{`${name}:`}</b>&nbsp;{`${d.text}`}</Chip>
            })
        } else {
            if (chipProps.dataItem.items) {
                return <Chip key={name} removable={true} rounded="large" size="small" className="status-chip"
                    onClick={() => props.updateObject(chipProps.dataItem.items, [], chipProps.dataItem.key, chipProps.dataItem.update, chipProps.dataItem.urlParam)}><b>{`${name}:`}</b>&nbsp;{`Oui`}</Chip>
            }
        }
    }, [props]);
    return <ChipList data={data} chip={getChipList} style={{ flexGrow: 1, flexWrap: 'wrap', justifyContent: 'center', flexShrink: 1 }}></ChipList>;
}